import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import styled from 'styled-components';
import { useMotoristaDetalhes } from './hooks/useMotoristaDetalhes';

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const Titulo = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`;

const Subtitulo = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 14px;
  color: #6c757d;
`;

const FieldGroup = styled.div`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h5`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
`;

const FieldRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 10px;
`;

const FieldItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.span`
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
  font-weight: 500;
`;

const Value = styled.span`
  font-size: 14px;
  color: #212529;
  font-weight: 400;
`;

const formatCPF = (cpf) => {
  if (!cpf) return '-';
  const cleaned = cpf.replace(/\D/g, '');
  if (cleaned.length !== 11) return cpf;
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

const MotoristaDetalhes = () => {
  const { motorista, loading, deleteLoading, handleVoltar, handleEditar, handleExcluir } = useMotoristaDetalhes();

  if (loading) {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <p>Carregando...</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Inicio' },
              { name: 'Motoristas', route: '/motoristas' },
              { name: 'Detalhes' },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <HeaderWrap>
                <div>
                  <Titulo>Detalhes do Motorista</Titulo>
                  {motorista?.Nome ? (
                    <Subtitulo>{motorista.Nome}</Subtitulo>
                  ) : null}
                </div>
                <ButtonContainer>
                  <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                    Voltar
                  </ButtonWithLoading>
                  <ButtonWithLoading
                    variant="outline-danger"
                    onClick={handleExcluir}
                    loading={deleteLoading || undefined}
                  >
                    Excluir
                  </ButtonWithLoading>
                  <ButtonWithLoading variant="primary" onClick={handleEditar}>
                    Editar
                  </ButtonWithLoading>
                </ButtonContainer>
              </HeaderWrap>

              <FieldGroup>
                <SectionTitle>Informações do Motorista</SectionTitle>
                <FieldRow>
                  <FieldItem>
                    <Label>Nome</Label>
                    <Value>{motorista?.Nome || '-'}</Value>
                  </FieldItem>
                  <FieldItem>
                    <Label>CPF</Label>
                    <Value>{formatCPF(motorista?.Cpf)}</Value>
                  </FieldItem>
                  <FieldItem>
                    <Label>Código de Integração</Label>
                    <Value>{motorista?.CodigoIntegracao || '-'}</Value>
                  </FieldItem>
                  <FieldItem>
                    <Label>Tipo</Label>
                    <Value>{motorista?.Tipo || '-'}</Value>
                  </FieldItem>
                </FieldRow>
              </FieldGroup>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MotoristaDetalhes;
